import Marquee from "react-fast-marquee";

const ITEMS = [
  "AIGP-Certified Leadership",
  "Zero-Trust Architecture",
  "Enterprise Risk",
  "Secure AI by Design",
  "EU AI Act Readiness",
  "Board-Level Assurance",
];

export default function TrustMarquee() {
  return (
    <section aria-label="Practice credentials" className="border-y border-gold/15 bg-surface/60 py-6">
      <Marquee speed={38} gradient gradientColor="#0A1B38" gradientWidth={140}>
        <div className="flex items-center">
          {ITEMS.map((item) => (
            <span
              key={item}
              className="flex items-center gap-16 pr-16 font-mono text-xs uppercase tracking-[0.3em] text-slate-400"
            >
              {item}
              <span className="inline-block h-1.5 w-1.5 rotate-45 bg-gold" aria-hidden="true" />
            </span>
          ))}
        </div>
      </Marquee>
    </section>
  );
}
